import { useLoaderData } from 'react-router';

import type { loader } from '~/routes/_app.product.$urlSegment';
import { DetailTestimonialBand } from '~/ui-rocco/pages/detail-shared';

/**
 * 06b — the pull quote: what has been said about the supplier who makes the
 * product, drawn by the shared band.
 */
export const ProductTestimonialSection = () => {
    const { product } = useLoaderData<typeof loader>();

    return (
        <DetailTestimonialBand
            label="Supplier Reviews"
            testimonials={product.Professional?.Testimonials ?? []}
        />
    );
};
